<template>
  <div class="logger-container" ref="logger">
    <template v-for="log in logs">
      <span :class="log.type">
        {{ log.text }}
      </span>
      <br />
    </template>
  </div>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
export default {
  name: "Logger",
  props: {
    topic: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      count: 0,
      logs: [],
    };
  },
  methods: {
    push(log) {
      this.logs.push(log);
      this.$nextTick(() => {
        this.$refs.logger.scrollTop = this.$refs.logger.scrollHeight;
      });
    },
  },
  mounted() {
    this.socket = new SockJS(
      `${process.env.VUE_APP_WEBSOCKET_BASE_URL}/gate-websocket?access_token=${this.$store.state.accessToken}`
    );
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.connect(
      { Authorization: `Bearer ${this.$store.state.accessToken}` },
      () => {
        this.stompClient.subscribe(`/topic/${this.topic}`, (message) => {
          this.push(JSON.parse(message.body));
        });
      },
      () => {}
    );
  },
  beforeDestroy() {
    this.stompClient.disconnect();
    this.stompClient = null;
    this.socket.close();
    this.socket = null;
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/app-variables";
@import "~element-ui/packages/theme-chalk/src/common/var.scss";
.logger {
  &-container {
    border: 1px solid $--app-sidebar-border-color;
    height: 100%;
    border-radius: 6px;
    padding: 8px;
    font-size: 12px;
    color: #7c7c7c;
    overflow: auto;
    font-family: monospace;
  }
}
.Error {
  color: $--color-danger;
  font-family: monospace;
}
.Success {
  color: $--color-success;
  font-family: monospace;
}
.Warning {
  color: $--color-warning;
  font-family: monospace;
}
.Info {
  color: $--color-info;
  font-family: monospace;
}
</style>
